module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAACE3AAAhNwEzWJ96AAAAlklEQVRIie3WQQ2AMAyF4X8oQAoCuCABI4jBCBK4IAApOICQ7LYDW9ulIdk7koVvXWgZLS21EnLfey/jAGzAHNbjTBYUJguO6A70wAVMWrxLnnznxfe4mboVk1aNtvJs2Bovgi3xYtgKF8EWuBjW4ipYg0v62CT/O2qXj8ulnVwGiMvIdPlJWKMI+9jkIuB29WlpqRPgAchiahj+tNfBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@3x/ic_breadcrumbs_arrow@3x.png
// module id = 886
// module chunks = 0